
import React from 'react';
import { Home, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Key } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const RealEstateLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Home,
      title: "Imóveis Disponíveis",
      subtitle: "Venda e locação",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-emerald-500 hover:bg-emerald-600"
    },
    {
      icon: Key,
      title: "Avaliação Gratuita",
      subtitle: "Avalie seu imóvel",
      url: "https://decidedigital.com.br/",
      bgColor: "bg-blue-500 hover:bg-blue-600"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Imóveis",
      subtitle: "Atendimento personalizado",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20im%C3%B3veis",
      bgColor: "bg-green-600 hover:bg-green-700"
    },
    {
      icon: Phone,
      title: "Central de Vendas",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      bgColor: "bg-indigo-500 hover:bg-indigo-600"
    },
    {
      icon: Mail,
      title: "Contato Comercial",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      bgColor: "bg-purple-500 hover:bg-purple-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-blue-50 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="bg-white rounded-3xl p-6 shadow-xl border-b-4 border-emerald-500 mb-6 animate-fade-in">
          <div className="text-center">
            <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-emerald-400 to-blue-500 rounded-full flex items-center justify-center">
              <Home className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Lar & Investimento</h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              🏠 Imobiliária especializada em residências e investimentos. 
              Encontre o imóvel dos seus sonhos com quem entende do mercado!
            </p>
          </div>
        </div>

        {/* QR Code for Properties */}
        <div className="bg-white rounded-2xl p-4 shadow-md mb-6 text-center animate-scale-in">
          <p className="text-gray-700 text-sm mb-3 font-medium">🏘️ Catálogo de Imóveis:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={110} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-5 h-5 text-emerald-600" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-3">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-4 ${link.bgColor} rounded-2xl text-white shadow-lg transition-all duration-300 transform hover:scale-105 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-lg">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Office Location */}
        <div className="bg-white rounded-2xl p-4 shadow-md mt-6 animate-fade-in">
          <p className="text-gray-700 text-sm mb-3 font-medium text-center">🏢 Visite nosso escritório:</p>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={16} />
        </div>

        {/* Trust Badge */}
        <div className="bg-emerald-500 rounded-2xl p-4 mt-4 text-white text-center animate-fade-in">
          <p className="font-semibold text-sm">✓ CRECI Licenciado</p>
          <p className="text-xs opacity-90">Mais de 500 famílias atendidas</p>
        </div>
      </div>
    </div>
  );
};

export default RealEstateLinktree;
